import { inject, Injectable } from '@angular/core';
import { PageViewEvent } from '../events/page-view-event';
import { AnalyticsEventProvider } from './analytics-event-provider.service';
import { GlobalPartnerStore } from '@ichoosr-core/partner/domain';
import { getSinglePagePath } from '../model/page-type';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsPageViewProvider extends AnalyticsEventProvider<PageViewEvent> {
  private readonly globalStore = inject(GlobalPartnerStore);

  createAndPush(path: string): void {
    const installerId = this.globalStore.installerId();
    const event: PageViewEvent = {
      event: 'page_view',
      page_path: path,
      single_page_path: getSinglePagePath(path),
      installer_id: installerId ?? undefined,
      installer_name: this.globalStore.installerName() ?? undefined,
      country: this.globalStore.country() ?? undefined,
    };
    this.push(event);
  }
}
